import axios from "axios";
import { AnalyticIngestEvent } from "../types/Analytics";

const username = process.env.REACT_APP_BASIC_AUTH_USERNAME;
const password = process.env.REACT_APP_BASIC_AUTH_PASSWORD;
const credentials = window.btoa(`${username}:${password}`);
export const economusBaseURL = "/api/economus";

export const xhr = axios.create({
  withCredentials: true,
  timeout: 10000,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: `Basic ${credentials}`,
  },
  baseURL:
    process.env.NODE_ENV === "development"
      ? "http://localhost:5006"
      : "https://kabiti-apis-a3c65789f9b2.herokuapp.com",
});

export const sendMessage = async (
  to: string,
  subject: string,
  data: Record<string, any>,
) => {
  return await xhr.post(`${economusBaseURL}/economus/send-message`, {
    to,
    subject,
    variables: data,
  });
};
export const getGalleryMedia = async () => {
  const response = await xhr.get(
    `${economusBaseURL}/gallery?withGroupName=true`,
  );
  return response.data.data;
};

export const getTranslationsByLang = async (lng: string) => {
  const response = await xhr.get(`${economusBaseURL}/translation/${lng}`);
  return response.data;
};

export const sendAnalytics = async (analytic: AnalyticIngestEvent) => {
  await xhr.post("/api/analytics/save", { ...analytic });
};
